import moment from 'moment';
import { createSelector } from 'reselect';
import type { PurchasesReduxState } from './types';

/**
 * purchasesSelector
 * Selector for the purchases state.
 */
export const purchasesSelector = (state: PurchasesReduxState) => state.insights.purchases;

/**
 * selectPurchases
 * Selects the purchases from the purchases state.
 */
export const selectPurchases = createSelector([purchasesSelector], (purchases) =>
  purchases.purchases.map((purchase, i) => {
    /** It was discovered that Safari cannot interpret the date format `yyyy-MM-DD hh:mm:ss +00:00`
     * due to the space before `+00:00`. The space technically does not comply with ISO 8601 standard,
     * even though Chrome has no problem parsing it. Reformat to match standard. */
    const formattedDate = moment(purchase.createdAt, 'yyyy-MM-DD hh:mm:ss Z')
      .toDate()
      .toISOString();
    return {
      ...purchase,
      /** Since the purchases returned from the API have no unique identifier, we need to add one to make sure that the react table can properly render the rows. */
      id: i,
      createdAt: formattedDate,
    };
  }),
);
